export const ADMIN = 'ADMIN'

export const ORGANIZATION_ROLES = {
  Owner: 'owner',
  Member: 'member',
}
